var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-card-text',[_vm._v(_vm._s(_vm.$t('general_no_data')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }